import React, { createContext, useContext } from 'react';

import { CoesOfferEntityNormalized } from '../../../../../../../store/product/types';

interface CoesAssetContextReceivedData {}

interface CoesAssetContextData extends CoesAssetContextReceivedData {
  modalOpen: boolean;
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  offerSelected: CoesOfferEntityNormalized | undefined;
  setOfferSelected: React.Dispatch<React.SetStateAction<CoesOfferEntityNormalized | undefined>>;
}

interface Props extends CoesAssetContextReceivedData {
  children: React.ReactNode;
}

const CoesAssetContext = createContext<CoesAssetContextData>({} as CoesAssetContextData);

const CoesAssetProvider: React.FC<Props> = ({ children, ...props }) => {
  const [modalOpen, setModalOpen] = React.useState(false);
  const [offerSelected, setOfferSelected] = React.useState<CoesOfferEntityNormalized>();

  return (
    <CoesAssetContext.Provider
      value={{
        ...props,
        modalOpen,
        setModalOpen,
        offerSelected,
        setOfferSelected,
      }}>
      {children}
    </CoesAssetContext.Provider>
  );
};

const useCoesAssetContext = (): CoesAssetContextData => {
  const context = useContext(CoesAssetContext);

  if (!context) {
    throw new Error('useCoesAssetContext must be used within an CoesAssetContext');
  }
  return context;
};

export { CoesAssetProvider, useCoesAssetContext, CoesAssetContextData };
